import './Thumbnail.scss';

import React from 'react';
import Dropzone from 'react-dropzone';
import classNames from 'classnames';

import Icon from 'components/Icon';

export default class Thumbnail extends React.Component {
    static propTypes = {
        defaultAvatar: React.PropTypes.string.isRequired,
        dropzone: React.PropTypes.bool,
        handleDrop: React.PropTypes.func,
        imgTag: React.PropTypes.bool,
        thumbnailToUpload: React.PropTypes.object,
        thumbnailID: React.PropTypes.number
    };

    _handleThumbnailDrop(file) {
        this.props.handleDrop(file[0]);
    }

    render() {
        let { defaultAvatar, dropzone, thumbnailID, thumbnailToUpload } = this.props;
        let defaultThumbnailHtml = <div className="thumbnail default-thumbnail"><Icon icon={defaultAvatar} /></div>;
        let customThumbnailHtml = <div className="thumbnail custom-thumbnail" style={{backgroundImage: `url(${process.env.API_URL}rest/file/${thumbnailID})`}}></div>;
        let uploadThumbnailHtml = <div className="thumbnail custom-thumbnail" style={thumbnailToUpload != null ? {backgroundImage: `url(${thumbnailToUpload.preview})`} : {}}></div>;

        if(this.props.imgTag === true) {
            customThumbnailHtml = <div className="thumbnail custom-thumbnail custom-thumbnail--img-tag"><img src={`${process.env.API_URL}rest/file/${thumbnailID}`} alt="" /></div>;
            uploadThumbnailHtml = <div className="thumbnail custom-thumbnail custom-thumbnail--img-tag">{thumbnailToUpload ? <img src={thumbnailToUpload.preview} alt="" /> : null}</div>
        }

        if(dropzone === true) {
            return (
                <div className={classNames('thumbnail-drop--wrapper', {'thumbnail-drop--has-thumbnail': thumbnailID || thumbnailToUpload})}>
                    {thumbnailID ? customThumbnailHtml : defaultThumbnailHtml}
                    <Dropzone className="thumbnail-drop"
                              activeClassName="thumbnail-drop--active"
                              accept="image/*"
                              onDrop={this._handleThumbnailDrop.bind(this)} multiple={false}
                              ref={(node) => { this.dropzone = node; }}
                              style={{}}
                              activeStyle={{}}>
                        {uploadThumbnailHtml}
                    </Dropzone>
                    <div className="thumbnail-drop__progress--overlay">
                        <div className="thumbnail-drop__progress--outer">
                            <div id="thumbnailProgress" className="thumbnail-drop__progress--inner"></div>
                        </div>
                        <div className="thumbnail-drop__progress--done">
                            <Icon icon="check" />
                        </div>
                    </div>
                    <div className="thumbnail-drop__upload-icon"
                         onClick={() => { this.dropzone.open(); }}>
                        <Icon icon="camera" />
                    </div>
                </div>
            );
        } else if(thumbnailToUpload) {
            return uploadThumbnailHtml;
        } else if(thumbnailID){
            return customThumbnailHtml;
        } else {
            return defaultThumbnailHtml;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Thumbnail/index.js